/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum NotificationActions {
  SET_ERROR = '[Notification] Set Error',
  SET_SUCCESS = '[Notification] Set Success',
}
